export const UCAT_DEFAULT_MODULE_MINUTES = {
  verbal_reasoning: 22,
  decision_making: 37,
  quantitative_reasoning: 26,
  situational_judgement: 26,
};

const DEFAULT_MINUTES = UCAT_DEFAULT_MODULE_MINUTES;

const GENERIC_MINUTES = new Set([40, 75, 90, 95]);

function parseMinutes(value) {
  if (typeof value === 'number' && Number.isFinite(value) && value > 0) return value;
  const match = String(value || '').match(/(\d+)/);
  if (match) return Number(match[1]);
  return null;
}

/** Payload minutes if they look like a subtest clock; else spec §7. Never 40 or 75. */
export function getUcatModuleDurationMinutes(mod) {
  const key = mod?.moduleKey;
  const fallback = DEFAULT_MINUTES[key] || 22;
  const candidate = parseMinutes(
    mod?.durationMinutes
    ?? mod?.exam_config?.duration
    ?? mod?.duration_minutes
    ?? mod?.duration
  );
  if (candidate == null || GENERIC_MINUTES.has(candidate)) return fallback;
  return candidate;
}

export function ucatInstructionAdvanceEvent() {
  return 'instructionsNext';
}
